import React from "react";
import { connect } from "react-redux";
import { userActions } from "../_actions";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    // reset login status
    this.props.dispatch(userActions.logout());

    this.state = {
      username: "",
      password: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear()
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  }

  render() {
    const { username, password } = this.state;
    return (
      <div className="login-body">
        <div className="container ">
          <form
            name="form"
            onSubmit={this.handleSubmit}
            className="form-signin"
          >
            <h2 className="form-signin-heading">VidyaMandir</h2>
            <div className="login-wrap">
              <div className="user-login-info">
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  placeholder="Username..."
                  value={username}
                  onChange={this.handleChange}
                  autoFocus
                />
                <input
                  id="form-password"
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  placeholder="Password..."
                  onChange={this.handleChange}
                />
              </div>
              <button
                type="submit"
                className="btn btn-lg btn-login btn-block"
              >
                <strong>Sign in</strong>
              </button>

            </div>
          </form>
          {/*<div className="row">
            <div className="login-container col-lg-4 col-md-6 col-sm-8 col-xs-12">
              <div className="login-title text-center">
                <h2>
                  <span>
                    Vidya<strong>Mandir</strong>
                  </span>
                </h2>
              </div>
              <div className="login-content">
                <div className="login-body">
                  <form
                    name="form"
                    onSubmit={this.handleSubmit}
                    className="login-form"
                  >
                    <div className="form-group ">
                      <div
                        className={
                          "form-group pos-r" +
                          (submitted && !username ? " has-error" : "")
                        }
                      >
                        <input
                          id="form-username"
                          type="text"
                          className="form-username form-control"
                          name="username"
                          placeholder="Username..."
                          value={username}
                          onChange={this.handleChange}
                        />
                        <i className="fa fa-user" />
                        {submitted &&
                        !username && (
                          <div className="help-block">Username is required</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div
                        className={
                          "form-group pos-r" +
                          (submitted && !password ? " has-error" : "")
                        }
                      >
                        <input
                          id="form-password"
                          type="password"
                          className="form-password form-control"
                          name="password"
                          value={password}
                          placeholder="Password..."
                          onChange={this.handleChange}
                        />
                        <i className="fa fa-lock" />
                        {submitted &&
                        !password && (
                          <div className="help-block">Password is required</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary form-control"
                      >
                        <strong>Sign in</strong>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>*/}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };
